import { CreditCardIcon, GiftIcon, HeartIcon, LifebuoyIcon, TrophyIcon } from '@heroicons/react/24/outline';
import { PetPawIcon } from '@/components/icons/PetPawIcon';

export type BenefitTypeDefinition = {
  slug: string;
  name: string;
  description: string;
  icon: typeof GiftIcon;
};

export const benefitTypes: BenefitTypeDefinition[] = [
  {
    slug: 'health-plan',
    name: 'Plano de saúde',
    description: 'Acompanhe contribuições, coparticipações e reembolsos dos convênios.',
    icon: HeartIcon,
  },
  {
    slug: 'health-promotion',
    name: 'Promoção a saúde',
    description: 'Reforce ações preventivas e campanhas de bem-estar.',
    icon: TrophyIcon,
  },
  {
    slug: 'food',
    name: 'Alimentação',
    description: 'Controle gastos e saldos de vale alimentação ou refeição.',
    icon: CreditCardIcon,
  },
  {
    slug: 'funeral-assistance',
    name: 'Auxílio funerário',
    description: 'Controle provisões e pagamentos de auxílio.',
    icon: LifebuoyIcon,
  },
  {
    slug: 'pet-plan',
    name: 'Plano pet',
    description: 'Visão de custos com assistência e saúde pet.',
    icon: PetPawIcon,
  },
];

export const benefitTypeBySlug = benefitTypes.reduce<Record<string, BenefitTypeDefinition>>((acc, type) => {
  acc[type.slug] = type;
  return acc;
}, {});
